<template lang="pug">
  div
    div.label.basic600--text.text-uppercase.mb-2 {{ $t('sort_orders_by') }}
    div.d-flex
      v-chip.button-AA-tiny.text-uppercase(label small :outlined="sortOrder === 'newest'" :color="sortOrder === 'newest' ? 'info500' : 'basic300'" :style="sortOrder === 'newest' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" @click="sortOrder = 'newest'") {{ $t('newest') }}
      v-chip.button-AA-tiny.text-uppercase.ml-2(label small :outlined="sortOrder === 'oldest'" :color="sortOrder === 'oldest' ? 'info500' : 'basic300'" :style="sortOrder === 'oldest' ? `background-color: ${$vuetify.theme.themes[$theme].infoT08} !important` : ''" @click="sortOrder = 'oldest'") {{ $t('oldest') }}
</template>

<script>
export default {
  name: 'SortOrder',
  props: ['parentSortOrder'],
  data: () => ({
  }),
  computed: {
    sortOrder: {
      get () {
        return this.parentSortOrder
      },
      set (newValue) {
        this.$emit('update:parentSortOrder', newValue)
      }
    },
  }
}
</script>

<i18n>
{
  "en": {
    "sort_orders_by": "Sort orders by"
  },
  "id": {
    "sort_orders_by": "Urutkan berdasarkan"
  }
}
</i18n>